import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import BohoPicnic from "@/pages/BohoPicnic";
import FloatingPicnic from "@/pages/FloatingPicnic";
import PicnicElectronic from "@/pages/PicnicElectronic";
import PrivateEvents from "@/pages/PrivateEvents";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import BookingConfirmation from "@/pages/BookingConfirmation";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminInquiries from "@/pages/admin/AdminInquiries";

function PublicLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function ReservationRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/booking${search}`} replace />;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/experiences/boho-picnic" element={<BohoPicnic />} />
              <Route path="/experiences/floating-picnic" element={<FloatingPicnic />} />
              <Route path="/experiences/picnic-electronic" element={<PicnicElectronic />} />
              <Route path="/private-events" element={<PrivateEvents />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/reservation" element={<ReservationRedirect />} />
              <Route path="*" element={<Navigate to="/" replace />} />
              <Route path="/booking/confirmation/:id" element={<BookingConfirmation />} />
              <Route path="/legal/privacy" element={<Legal page="privacy" />} />
              <Route path="/legal/terms" element={<Legal page="terms" />} />
              <Route path="/legal/cookies" element={<Legal page="cookies" />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="inquiries" element={<AdminInquiries />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
